import axios from './axios';

/**
 * @api post /pupils/search Request students search
 * @param {Object} filter Student search filter
 * @return {Promise}
 * */
export const searchStudents = (filter, pagination) =>
  axios.post('/pupils/search', {
    filter,
    pagination,
  });

/**
 * @api post /pupils/${studentId}/location/history/requests Request students search
 * @param {sting} studentId StudentId
 * @param {Object} query Location requests search filter
 * @return {Promise}
 * */
export const searchLocationRequests = (studentId, query) =>
  axios.post(`/pupils/${studentId}/location/history/requests`, query);

/**
 * @api get /pupils/search Request relatives of student
 * @param {sting} studentId StudentId
 * @return {Promise}
 * */
export const getParents = studentId => axios.get(`/pupils/${studentId}/relatives`);

/**
 * @api get /pupils/{studentId} Request get student by ID
 * @param {Object} studentId Student search filter
 * @return {Promise}
 * */
export const getStudentById = studentId => axios.get(`/pupils/${studentId}`);

/**
 * @api get /pupils/{studentId}/location Request student location
 * @param {string} studentId StudentId
 * @return {Promise}
 * */
export const getStudentLocation = studentId => axios.get(`/pupils/${studentId}/location`);

/**
 * @api get /pupils/{pupilId}/insurances Get insurance by studentID
 * @param {String} studentId StudentID
 * @return {Promise}
 * */
export const getInsurances = studentId => axios.get(`/pupils/${studentId}/insurances`);

/**
 * @api post /student/{studentId}/absences/search Search absense
 * @param {String} studentId
 * @param {Object} req - search query
 * @return {Promise}
 * */
export const searchAbsences = (studentId, req) =>
  axios.post(`/students/${studentId}/absences/search`, req);

/**
 * @api post /student/{studentId}/absences Create absense
 * @param {object} absense
 * @return {Promise}
 * */
export const createAbsence = (studentId, absence) =>
  axios.post(`/students/${studentId}/absences`, absence);

/**
 * @api put /student/{studentId}/absences/{id} Update absence
 * @param {string} studentId
 * @param {string} absenceId
 * @param {object} absense
 * @return {Promise}
 * */
export const editAbsence = (studentId, absenceId, absence) =>
  axios.put(`/students/${studentId}/absences/${absenceId}`, absence);

/**
 * @api delete /student/{studentId}/absence/{id} Delete absence by id
 * @param {string} id
 * @return {Promise}
 * */
export const removeAbsence = (studentId, id) =>
  axios.delete(`/students/${studentId}/absences/${id}`);
/**
 * @api put /student/{studentId}/absence/{id} Delete absence by id
 * @param {string} id
 * @return {Promise}
 * */
export const stopAbsence = (studentId, id) =>
  axios.put(`/students/${studentId}/absences/${id}/stop`);

/**
 * @api get /students/absences/reasons Get list of absence reasons
 * */
export const getAbsenceReasons = () => axios.get(`/students/absences/reasons`);
